export default __webpack_public_path__ + "static/media/Mask Group 1.ddc19758.png";